
define('text!views/secured/lists/access.html',[],function () { return '<div id="list-access" class="page-content">\r\n    <div id="list-accesscontrol" data-bind="fp_accesscontrol: { data: accessData }"></div>\r\n</div>\r\n\r\n\r\n';});

